"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var constants_1 = require("./constants");
function warnWithoutContext() {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var key = _a[0];
    if (process.env.NODE_ENV !== 'production') {
        console.error(constants_1.NO_POLYGLOT_CONTEXT);
    }
    return key;
}
/**
 * The central store for i18n related components.
 */
var I18nContext = React.createContext({
    locale: undefined,
    t: warnWithoutContext,
});
exports.default = I18nContext;
